(function () {

  'use strict';


  /* =====================================================
     SETTINGS
     ===================================================== */

  const PRODUCT_SELECTOR =
    '#ProductsList .product-column';

  const GRID_SELECTOR =
    '#ProductsList';

  const COUNTER_SELECTOR =
    '#tdk-product-counter';

  const NUMBER_SELECTOR =
    '#image_number';

  const TOTAL_SELECTOR =
    '#total_product_count';


  /*
   * Counter appears when product grid reaches
   * this position.
   */
  const GRID_START_OFFSET = 180;


  /* =====================================================
     GET ELEMENTS
     ===================================================== */

  function getCounter() {

    return document.querySelector(
      COUNTER_SELECTOR
    );

  }


  function getGrid() {

    return document.querySelector(
      GRID_SELECTOR
    );

  }


  function getProducts() {

    return Array.from(
      document.querySelectorAll(
        PRODUCT_SELECTOR
      )
    );

  }


  /* =====================================================
     GET TOTAL PRODUCTS
     ===================================================== */

  function getTotalProducts() {

    const counter =
      getCounter();


    if (!counter) {
      return 0;
    }


    const total =
      parseInt(
        counter.dataset.total,
        10
      );


    if (
      Number.isFinite(total)
    ) {

      return total;

    }


    const totalElement =
      document.querySelector(
        TOTAL_SELECTOR
      );


    if (totalElement) {

      const fallback =
        parseInt(
          totalElement.textContent,
          10
        );


      if (
        Number.isFinite(fallback)
      ) {

        return fallback;

      }

    }


    return 0;

  }


  /* =====================================================
     GET PAGE SIZE
     ===================================================== */

  function getPageSize() {

    const counter =
      getCounter();


    if (!counter) {
      return 10;
    }


    const pageSize =
      parseInt(
        counter.dataset.pageSize,
        10
      );


    if (
      Number.isFinite(pageSize) &&
      pageSize > 0
    ) {

      return pageSize;

    }


    return 10;

  }


  /* =====================================================
     GET CURRENT PAGE
     ===================================================== */

  function getCurrentPage() {

    const counter =
      getCounter();


    /*
     * First use Liquid value.
     */
    if (counter) {

      const liquidPage =
        parseInt(
          counter.dataset.currentPage,
          10
        );


      if (
        Number.isFinite(liquidPage) &&
        liquidPage > 0
      ) {

        return liquidPage;

      }

    }


    /*
     * Fallback to URL.
     *
     * ?page=2
     */
    const params =
      new URLSearchParams(
        window.location.search
      );


    const urlPage =
      parseInt(
        params.get('page'),
        10
      );


    if (
      Number.isFinite(urlPage) &&
      urlPage > 0
    ) {

      return urlPage;

    }


    return 1;

  }


  /* =====================================================
     GET PAGE OFFSET
     ===================================================== */

  function getPageOffset() {

    const page =
      getCurrentPage();

    const pageSize =
      getPageSize();


    return (
      (page - 1) *
      pageSize
    );

  }


  /* =====================================================
     GET CURRENT GRID COLUMNS
     =====================================================
     
     Your CSS:

     --f-columns-mobile: 2;
     --f-columns-md: 3;
     --f-columns-lg: 4;
     --f-columns-xl: 5;

     Instead of hardcoding 5, we detect the
     actual rendered grid.

     Mobile:
     2

     Tablet:
     3

     Laptop:
     4

     Desktop:
     5
     */

  function getColumnsPerRow() {

    const grid =
      getGrid();


    if (!grid) {
      return 1;
    }


    /*
     * Best method:
     *
     * Read actual CSS grid template.
     *
     * Example:
     *
     * "180px 180px"
     *
     * = 2 columns
     *
     * "200px 200px 200px"
     *
     * = 3 columns
     */

    const computedStyle =
      window.getComputedStyle(
        grid
      );


    const gridColumns =
      computedStyle.gridTemplateColumns;


    if (
      gridColumns &&
      gridColumns !== 'none'
    ) {

      /*
       * split() works because browser returns
       * resolved grid columns.
       */
      const columns =
        gridColumns
          .split(' ')
          .filter(Boolean);


      if (
        columns.length > 0
      ) {

        return columns.length;

      }

    }


    /*
     * Fallback based on viewport.
     */
    const width =
      window.innerWidth;


    if (width < 768) {
      return 2;
    }


    if (width < 1024) {
      return 3;
    }


    if (width < 1280) {
      return 4;
    }


    return 5;

  }


  /* =====================================================
     GET PRODUCTS PASSED
     ===================================================== */

  function getPassedProducts() {

    const products =
      getProducts();


    if (!products.length) {
      return 0;
    }


    let passedProducts = 0;


    for (
      let i = 0;
      i < products.length;
      i++
    ) {

      const rect =
        products[i].getBoundingClientRect();


      /*
       * Product reached the counter line.
       */
      if (
        rect.top <=
        GRID_START_OFFSET
      ) {

        passedProducts =
          i + 1;

      } else {

        break;

      }

    }


    return passedProducts;

  }


  /* =====================================================
     GET CURRENT ROW
     ===================================================== */

  function getCurrentRow() {

    const passedProducts =
      getPassedProducts();


    if (
      passedProducts <= 0
    ) {

      return 1;

    }


    /*
     * IMPORTANT:
     *
     * This is now dynamic.
     *
     * Mobile:
     * columns = 2
     *
     * Desktop:
     * columns = 5
     */
    const columns =
      getColumnsPerRow();


    const row =
      Math.ceil(
        passedProducts /
        columns
      );


    return Math.max(
      1,
      row
    );

  }


  /* =====================================================
     GET CURRENT ROW COUNT
     ===================================================== */

  function getCurrentProductNumber() {

    const currentRow =
      getCurrentRow();


    const pageOffset =
      getPageOffset();


    /*
     * Get actual columns.
     */
    const columns =
      getColumnsPerRow();


    /*
     * Row based count.
     *
     * Mobile:
     *
     * Row 1 = 2
     * Row 2 = 4
     * Row 3 = 6
     *
     *
     * Desktop:
     *
     * Row 1 = 5
     * Row 2 = 10
     * Row 3 = 15
     */
    let currentNumber =
      pageOffset +
      (
        currentRow *
        columns
      );


    /*
     * Don't exceed total collection count.
     */
    const total =
      getTotalProducts();


    if (
      total > 0 &&
      currentNumber > total
    ) {

      currentNumber =
        total;

    }


    return currentNumber;

  }


  /* =====================================================
     UPDATE NUMBER
     ===================================================== */

  function updateCounterNumber() {

    const numberElement =
      document.querySelector(
        NUMBER_SELECTOR
      );


    if (!numberElement) {
      return;
    }


    const products =
      getProducts();


    if (!products.length) {
      return;
    }


    const currentNumber =
      getCurrentProductNumber();


    numberElement.textContent =
      currentNumber;

  }


  /* =====================================================
     SHOW / HIDE COUNTER
     ===================================================== */

  function updateCounterVisibility() {

    const counter =
      getCounter();

    const grid =
      getGrid();


    if (
      !counter ||
      !grid
    ) {

      return;

    }


    const rect =
      grid.getBoundingClientRect();


    /*
     * Product grid reached counter position.
     */
    const gridStarted =
      rect.top <=
      GRID_START_OFFSET;


    /*
     * Grid is still visible.
     */
    const gridVisible =
      rect.bottom >
      GRID_START_OFFSET;


    if (
      gridStarted &&
      gridVisible
    ) {

      counter.classList.add(
        'is-visible'
      );

    } else {

      counter.classList.remove(
        'is-visible'
      );

    }

  }


  /* =====================================================
     UPDATE EVERYTHING
     ===================================================== */

  function updateCounter() {

    updateCounterVisibility();

    updateCounterNumber();

  }


  /* =====================================================
     SCROLL OPTIMIZATION
     ===================================================== */

  let ticking = false;


  function handleScroll() {

    if (ticking) {
      return;
    }


    ticking = true;


    window.requestAnimationFrame(
      function () {

        updateCounter();

        ticking = false;

      }
    );

  }


  /* =====================================================
     RESIZE
     =====================================================
     
     VERY IMPORTANT:
     
     When user changes:

     Desktop → Mobile

     5 columns → 2 columns

     We recalculate the counter.
     */

  let resizeTimer;


  window.addEventListener(
    'resize',
    function () {

      clearTimeout(
        resizeTimer
      );


      resizeTimer =
        setTimeout(
          function () {

            updateCounter();

          },
          100
        );

    }
  );


  /* =====================================================
     PRODUCT GRID OBSERVER
     ===================================================== */

  let productObserver = null;


  function observeProductGrid() {

    const grid =
      getGrid();


    if (!grid) {
      return;
    }


    if (productObserver) {

      productObserver.disconnect();

    }


    productObserver =
      new MutationObserver(
        function (mutations) {

          let productsChanged =
            false;


          for (
            const mutation of mutations
          ) {

            if (
              mutation.type ===
                'childList' &&
              mutation.addedNodes.length > 0
            ) {

              productsChanged =
                true;

              break;

            }

          }


          if (
            productsChanged
          ) {

            setTimeout(
              function () {

                updateCounter();

              },
              100
            );

          }

        }
      );


    productObserver.observe(
      grid,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /* =====================================================
     DOCUMENT OBSERVER
     ===================================================== */

  let documentObserver = null;


  function observeDocument() {

    if (documentObserver) {

      documentObserver.disconnect();

    }


    documentObserver =
      new MutationObserver(
        function () {

          setTimeout(
            function () {

              updateCounter();

              observeProductGrid();

            },
            200
          );

        }
      );


    documentObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /* =====================================================
     SHOPIFY SECTION LOAD
     ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        function () {

          updateCounter();

          observeProductGrid();

        },
        300
      );

    }
  );


  /* =====================================================
     BROWSER BACK / FORWARD
     ===================================================== */

  window.addEventListener(
    'popstate',
    function () {

      setTimeout(
        function () {

          updateCounter();

          observeProductGrid();

        },
        300
      );

    }
  );


  /* =====================================================
     SCROLL
     ===================================================== */

  window.addEventListener(
    'scroll',
    handleScroll,
    {
      passive: true
    }
  );


  /* =====================================================
     INITIALIZE
     ===================================================== */

  function initialize() {

    updateCounter();

    observeProductGrid();

    observeDocument();


    setTimeout(
      updateCounter,
      300
    );


    setTimeout(
      updateCounter,
      1000
    );


    setTimeout(
      function () {

        updateCounter();

        observeProductGrid();

      },
      2000
    );

  }


  /* =====================================================
     START
     ===================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }

})();
